module.exports = "<div class=\"skin-psh sidebar-mini\">\r\n  <div>\r\n    <app-header></app-header>\r\n    <app-left-side></app-left-side>\r\n    <div class=\"content-wrapper hm-height\">\r\n      <section class=\"content\">\r\n        <router-outlet></router-outlet>\r\n      </section>\r\n    </div>\r\n    <app-footer></app-footer>\r\n    <app-control-sidebar></app-control-sidebar>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/layout.component.html
// module id = ./src/app/containers/layout/layout.component.html
// module chunks = main